import { service } from "@ember/service";
import Route from "@ember/routing/route";
import RSVP from "rsvp";
import { findAll } from "@warp-drive/legacy/compat/builders";
import ENV from "glesys-controlpanel/config/environment";

export default class FileStorageVolumesCreateRoute extends Route {
  @service ajax;
  @service abilities;
  @service router;
  @service store;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  model() {
    let { project } = this.modelFor("organization");
    let plans = this.ajax.request(`${ENV.apiBaseUri}/filestorage/listplans?projectkey=${project.id}`);

    return RSVP.hash({
      dataCenters: this.store.request(findAll("data-center")).then((response) => response.content),
      plans,
      project,
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    controller.setProperties({
      hasAutoPromotion: true,
      name: "",
      selectedDataCenter: "Stockholm",
      selectedPlan: model.plans.plans.at(0),
    });
  }
}
